import React from "react";
import {Navbar, Nav} from 'react-bootstrap';

function Navigation() {
  return (
    <section>
      <Navbar expand="lg" className="website-nav flex-lg-column" fixed="top">
        <Navbar.Brand href="/">Ocean and Dexter's Kitchen</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        <ul className="navbar-nav ml-auto mr-auto">
          <Nav.Item>
            <Nav.Link href="/">Home</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/recipes">Recipes</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/about">About</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/contact">Contact</Nav.Link>
          </Nav.Item>
        </ul>
        </Navbar.Collapse>
      </Navbar>
    </section>
  );
}

export default Navigation;
